'use client';

import React from 'react';
import { twMerge } from 'utilities/src/twMerge';
import ChevronRight from '../../icons/DS/_ChevronRight';
import IconComponent, { IIconsProps } from '../Icon';
import BreadcrumbItem from './BreadcrumbItem';
import useBreadcrumbsTheme from './themes';
import formatStructuredData from './utils/_formatStructuredData';

export type BreadcrumbsItemType = {
  label?: string;
  labelClasses?: string;
  href?: string;
};

export type BreadcrumbsType = {
  items: BreadcrumbsItemType[];
  Icon?: IIconsProps['Icon'];
  iconName?: IIconsProps['iconName'];
  iconClasses?: string;
  customListClasses?: string;
  anchorClasses?: string;
  customSeparatorClasses?: string;
  itemLabelClasses?: string;
};

function Breadcrumbs({
  items,
  Icon,
  iconClasses,
  customListClasses,
  anchorClasses,
  customSeparatorClasses,
  itemLabelClasses,
  iconName,
}: BreadcrumbsType) {
  const {
    lastElementClasses,
    listVariantClasses,
    breadcrumbsContainer,
    commonListClasses,
    breadcrumbsListClasses,
  } = useBreadcrumbsTheme();
  return (
    <>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(formatStructuredData({ items })) }}
      />
      <ol className={twMerge(listVariantClasses, commonListClasses, customListClasses ?? breadcrumbsListClasses)}>
        {items.map((breadcrumb, i) => (
          <li key={`breadcrumb-${breadcrumb.label}`} className={breadcrumbsContainer}>
            <BreadcrumbItem
              href={breadcrumb.href}
              label={breadcrumb.label}
              metaContent={(i + 1).toString()}
              Icon={i === 0 ? Icon : undefined}
              iconName={i === 0 ? iconName : undefined}
              iconClasses={iconClasses}
              active={items.length === i + 1}
              anchorClasses={anchorClasses}
              labelClasses={twMerge(breadcrumb.labelClasses, itemLabelClasses)}
            />
            {items.length !== i + 1 && (
              <span className={twMerge(lastElementClasses, customSeparatorClasses)}>
                <IconComponent
                  Icon={ChevronRight}
                  size="IconS"
                  options={{ className: twMerge('fill-site-neutrals-900 inline', customSeparatorClasses) }}
                />
              </span>
            )}
          </li>
        ))}
      </ol>
    </>
  );
}

export default Breadcrumbs;
